import { render, staticRenderFns } from "./AppointmentReportPreview.vue?vue&type=template&id=de070148&scoped=true&"
import script from "./AppointmentReportPreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentReportPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de070148",
  null
  
)

export default component.exports